<nav class="navbar bg-primary navbar-expand-lg d-none d-lg-flex justify-content-between aling-items-center">
  <a
    class="navbar-brand py-0 m-0"
    [routerLink]="['/']"
    routerLinkActive="router-link-active"
    attr.aria-label="{{ 'nav.home.page.screenreader' | translate: { fgbdefault: 'Move to home page' } }}"
  >
    <label id="homeLink" class="accessibility-only">Go To Home Page</label>
    <img
      alt="imagedetails"
      class="m-0"
      aria-labelledby="homeLink"
      [src]="'logos/logo.svg' | contentAssetImage"
      draggable="false"
    />
  </a>

  <!-- middle Side Content -->
  <ul class="navbar-nav" #greedyNav>
    <li class="nav-item active">
      <a
        class="nav-link"
        [routerLink]="['/rewards']"
        routerLinkActive="router-link-active"
        attr.aria-label="{{ 'nav.rewards.screenreader' | translate: { fgbdefault: 'Move to rewards page' } }}"
        >{{ 'nav.rewards' | translate }}</a
      >
    </li>

    <li class="nav-item active">
      <a
        class="nav-link"
        [routerLink]="['/challenges']"
        routerLinkActive="router-link-active"
        attr.aria-label="{{ 'nav.badges.screenreader' | translate: { fgbdefault: 'Move to badges page' } }}"
        >{{ 'nav.badges' | translate }}</a
      >
    </li>

    <li class="nav-item active">
      <a
        class="nav-link"
        [routerLink]="['/games']"
        routerLinkActive="router-link-active"
        attr.aria-label="{{ 'nav.games.screenreader' | translate: { fgbdefault: 'Move to Games page' } }}"
        >{{ 'nav.games' | translate }}</a
      >
    </li>

    <li class="nav-item active">
      <a
        class="nav-link"
        [routerLink]="['/loadedtickets']"
        routerLinkActive="router-link-active"
        attr.aria-label="{{ 'nav.loadedtickets.screenreader' | translate: { fgbdefault: 'Move to Loaded Ticket page' } }}"
        >{{ 'nav.loaded.tickets' | translate }}</a
      >
    </li>

    <li class="nav-item active">
      <a
        class="nav-link"
        [routerLink]="['/rewards/wallet']"
        routerLinkActive="router-link-active"
        attr.aria-label="{{ 'nav.wallet.screenreader' | translate: { fgbdefault: 'Move to Wallet page' } }}"
        >{{ 'nav.sporting.pay' | translate }}</a
      >
    </li>
  </ul>

  <!-- Right Side Content -->
  <div class="right-side-nav-bar d-flex align-items-center justify=content-center">
    <div class="balance-container d-flex align-items-center justify-content-center">
      <div class="balance bg-glass mx-0">
        <div class="d-flex align-items-center justify-content-center" *ngIf="loyaltyPointsCard$">
          <span class="icons material-icons text-white" aria-hidden="true">loyalty</span>
          <label class="fw-bold text-white"
            >{{ loyaltyPointsCard$ | async | number: '1.0-0' }} {{ 'fgbcl.currency.pts' | translate }}</label
          >
        </div>
      </div>

      <div class="balance bg-glass mx-0">
        <div class="d-flex align-items-center justify-content-center" *ngIf="loyaltyPointsCard$">
          <span class="icons material-symbols-outlined text-white"> money_bag </span>
          <label class="fw-bold text-white">{{ combinedCard$ | async | FortressCurrencyPipe }}</label>
        </div>
      </div>
    </div>

    <!--Notifications-->
    <fgb-notification-button></fgb-notification-button>

    <!-- side nav -->
    <button
      class="nav-link btn d-flex align-items-center mx-0 px-0 justify-content-end"
      (click)="isNavOpen = !isNavOpen"
      id="namedropdown"
      attr.aria-label="{{ 'nav.account.menu.screenreader' | translate }}"
      tabindex="-1"
      focusTab
    >
      <i class="material-symbols-outlined text-white">menu</i>
    </button>
  </div>
</nav>

<ng-template #memberDetailsLoading>
  <div class="user-box d-block text-center text-on-primary px-4">
    <fgbcl-loading [size]="'small'"></fgbcl-loading>
  </div>
</ng-template>

<div class="right-nav-menu-overlay" *ngIf="isNavOpen" [@rightMenuOverlayAnimation]></div>
<div class="right-nav-menu" [@rightNavAnimation]="isNavOpen ? 'open' : 'close'" [ngClass]="{ open: isNavOpen }">
  <div class="d-flex flex-column">
    <div class="right-nav-header d-flex flex-row align-items-center justify-content-between">
      <img
        alt="local_grocery_store"
        class="right-nav-logo"
        aria-labelledby="homeLink"
        [src]="'logos/logo.svg' | contentAssetImage"
        draggable="false"
      />
      <!-- Close Button -->
      <button type="button" class="btn-close position-absolute" (click)="isNavOpen = false" aria-label="Close"></button>
    </div>

    <div class="member-card-container">
      <div class="d-flex flex-column">
        <h5
          class="fw-bold card-name d-flex align-items-center flex-wrap mb-0 text-primary text-uppercase font-size-16"
          *ngIf="memberDetails$ | async as memberDetails"
        >
          {{ memberDetails.FirstName }} {{ memberDetails?.Surname }}
        </h5>

        <div class="font-size-10 mb-1" *ngIf="card$ | async as card">
          <div class="membership-id">
            <span *ngIf="(card.ProductCode | productCode | translate) === 'Season Ticket Member'"
              >{{ 'member.card.membership.label' | translate }}
            </span>
            <span *ngIf="(card.ProductCode | productCode | translate) !== 'Season Ticket Member'"
              >{{ 'member.card.membership.buyer.label' | translate }}
            </span>

            <span> {{ card.ExternalRefNumber }}</span>
          </div>
        </div>
      </div>

      <fgb-ecash-button [isMemberCard]="false"></fgb-ecash-button>
    </div>

    <div class="right-nav-menu-list">
      <!-- Nav Buttons -->
      <a
        class="right-nav-menu-item"
        data-bs-dismiss="offcanvas"
        [routerLink]="['/account']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <span class="nav-text">{{ 'nav.account' | translate }}</span>
      </a>

      <a
        class="right-nav-menu-item"
        data-bs-dismiss="offcanvas"
        [routerLink]="['/earn']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <span class="nav-text">{{ 'nav.earn' | translate }}</span>
      </a>

      <a
        class="right-nav-menu-item"
        data-bs-dismiss="offcanvas"
        [routerLink]="['/worksheet']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <span class="nav-text">{{ 'nav.gallery' | translate }}</span>
      </a>

      <a
        class="right-nav-menu-item"
        data-bs-dismiss="offcanvas"
        [routerLink]="['/payment']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <span class="nav-text">{{ 'nav.payment' | translate }}</span>
      </a>

      <a
        class="right-nav-menu-item"
        data-bs-dismiss="offcanvas"
        [routerLink]="['/faq']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <span class="nav-text">{{ 'nav.faq' | translate }}</span>
      </a>

      <a
        class="right-nav-menu-item"
        data-bs-dismiss="offcanvas"
        [routerLink]="['/terms']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <span class="nav-text">{{ 'nav.terms' | translate }}</span>
      </a>

      <a
        class="right-nav-menu-item"
        data-bs-dismiss="offcanvas"
        [routerLink]="['/contact']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <span class="nav-text">{{ 'nav.contact.us' | translate }}</span>
      </a>

      <a class="log-out" data-bs-dismiss="offcanvas" (click)="logout()">
        <i class="material-icons fw-bold">logout</i>
        <span class="nav-text">{{ 'nav.log.out' | translate }}</span>
      </a>
    </div>
  </div>
</div>
